<script setup>
import { ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';
import { useAlert } from 'dashboard/composables';
import { useRouter } from 'vue-router';
import { useAccount } from 'dashboard/composables/useAccount';
import PageHeader from '../../SettingsSubPageHeader.vue';
import NextButton from 'dashboard/components-next/button/Button.vue';
import PlatformTooltipIcon from 'dashboard/components-next/PlatformTooltipIcon.vue';

const { t } = useI18n();
const store = useStore();
const router = useRouter();
const { accountId } = useAccount();

const inboxName = ref('');

const uiFlags = computed(() => store.getters['inboxes/getUIFlags']);

const createChannel = async () => {
  if (!inboxName.value.trim()) {
    useAlert(t('INBOX_MGMT.ADD.WHATSAPP_WEB.VALIDATION.NAME_REQUIRED'));
    return;
  }

  try {
    const apiChannel = await store.dispatch('inboxes/createChannel', {
      name: inboxName.value.trim(),
      channel: {
        type: 'api',
        webhook_url: '',
        // [FIX 2026-02-09] Mark as whatsapp_web platform so the frontend
        // shows the WhatsApp icon instead of the generic API icon
        additional_attributes: {
          platform_type: 'whatsapp_web',
        },
      },
    });

    router.replace({
      name: 'settings_inboxes_add_agents',
      params: {
        page: 'new',
        inbox_id: apiChannel.id,
      },
    });
  } catch (error) {
    useAlert(
      error.message || t('INBOX_MGMT.ADD.WHATSAPP_WEB.API.ERROR_MESSAGE')
    );
  }
};
</script>

<template>
  <div class="h-full w-full p-6 col-span-6">
    <PageHeader
      :header-title="$t('INBOX_MGMT.ADD.WHATSAPP_WEB.CHANNEL_NAME.LABEL')"
      :header-content="$t('INBOX_MGMT.ADD.WHATSAPP_WEB.CHANNEL_NAME.SUBTITLE')"
    />
    <form
      class="flex flex-wrap flex-col mx-0"
      @submit.prevent="createChannel()"
    >
      <div class="flex-shrink-0 flex-grow-0">
        <label>
          <span class="flex items-center gap-2">
            {{ $t('INBOX_MGMT.ADD.WHATSAPP_WEB.CHANNEL_NAME.LABEL') }}
            <PlatformTooltipIcon identifier="inbox_whatsapp_name" size="sm" />
          </span>
          <input
            v-model="inboxName"
            type="text"
            :placeholder="
              $t('INBOX_MGMT.ADD.WHATSAPP_WEB.CHANNEL_NAME.PLACEHOLDER')
            "
          />
        </label>
        <p class="help-text">
          {{ $t('INBOX_MGMT.ADD.WHATSAPP_WEB.CHANNEL_NAME.INFO') }}
        </p>
      </div>

      <div class="w-full mt-4">
        <NextButton
          :is-loading="uiFlags.isCreating"
          type="submit"
          solid
          blue
          :label="$t('INBOX_MGMT.ADD.WHATSAPP_WEB.SUBMIT')"
        />
      </div>
    </form>
  </div>
</template>
